import React from "react"

function Environment({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.6458 18.9794V11.9492H15.7883V18.9794"
        stroke="#003E4C"
        strokeWidth="0.998928"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0921 10.6309H7.85187V24.2651H11.0921V10.6309Z"
        stroke="#003E4C"
        strokeWidth="0.998928"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 24.2676H26.0232"
        stroke="#003E4C"
        strokeWidth="0.998928"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 26.6885H26.0232"
        stroke="#003E4C"
        strokeWidth="0.998928"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.1715 9.31055C21.854 13.6143 20.8537 16.7727 25.1715 17.7829"
        stroke="#003E4C"
        strokeWidth="0.998928"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.1721 9.31181C28.4897 13.6156 29.49 16.7739 25.1721 17.7842"
        stroke="#003E4C"
        strokeWidth="0.998928"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1726 18.9805H25.1715"
        stroke="#003E4C"
        strokeWidth="0.998928"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.1614 24.2295V9.31055"
        stroke="#003E4C"
        strokeWidth="0.998928"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9309 18.9372V13.1602H19.8025V18.9805"
        stroke="#003E4C"
        strokeWidth="0.998928"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Environment
